import 'core-js/features/array/find-index';

import { useContext, useEffect } from 'react';

import { LocationContext } from '../components/LocationContext';
import { EventLocation } from '../LegacyModal/EventForm';
import { bookingEntryAddressParser } from './addressComponentHelper';

interface UseBookingsAddress {
  setFieldValue: Function;
  // @ts-ignore
  values;
}

interface SetValues {
  index: number;
  gdsAddress: EventLocation;
  vendorName?: string | null;
}

export const useBookingsAddress = ({ setFieldValue, values }: UseBookingsAddress): void => {
  const {
    location: { CER, REC },
  } = useContext(LocationContext);

  useEffect(() => {
    const setValues = ({ index, gdsAddress = {}, vendorName }: SetValues): void => {
      setFieldValue(`subEvents[${index}].location.zip`, gdsAddress.zip);
      setFieldValue(`subEvents[${index}].location.city`, gdsAddress.city);
      setFieldValue(`subEvents[${index}].location.state`, gdsAddress.state);
      setFieldValue(`subEvents[${index}].location.country`, gdsAddress.country);
      setFieldValue(`subEvents[${index}].location.street1`, gdsAddress.street1);
      setFieldValue(`subEvents[${index}].location.name`, vendorName);
    };

    if (CER) {
      // @ts-ignore
      const index = values.subEvents.findIndex(e => e.type === 'Ceremony');

      if (index >= 0) {
        const { gdsAddress = {}, vendor_name } = bookingEntryAddressParser(CER);
        setValues({ index, gdsAddress, vendorName: vendor_name });
      }
    }

    if (REC) {
      // @ts-ignore
      const index = values.subEvents.findIndex(e => e.type === 'Reception');

      if (index >= 0) {
        const { gdsAddress = {}, vendor_name } = bookingEntryAddressParser(REC);
        setValues({ index, gdsAddress, vendorName: vendor_name });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values, CER, REC]);
};
